import { useRouter } from "solito/router";
import { Clock5 } from "@tamagui/lucide-icons";
import { LoadingButton, Paragraph, Subheadline2, Text, YStack } from "@medbillai/ui";
import { ScreenViewShadowCircle } from "../../components/ScreenView";
import { ShadowCircleHeader } from "../../components/ShadowCircleHeader";
import { useAccountLinkNavigation } from "../../lib/accounts-link/utils";
export function UnsupportedPlanScreen() {
  const {
    replace
  } = useRouter();
  const navigation = useAccountLinkNavigation();
  const nextPage = () => {
    // navigation.exit already accounts for isOnboarding from the store
    replace(navigation.exit, undefined, {
      experimental: {
        nativeBehavior: "stack-replace",
        isNestedNavigator: true
      }
    });
  };
  return <ScreenViewShadowCircle renderBefore={false} renderAfter={<YStack f={1} $platform-web={{
    pb: "$4.5"
  }}>
          <LoadingButton onPress={nextPage} f={1}>
            Continue
          </LoadingButton>
        </YStack>} data-sentry-element="ScreenViewShadowCircle" data-sentry-component="UnsupportedPlanScreen" data-sentry-source-file="unsupported-plan.tsx">
      <ShadowCircleHeader data-sentry-element="ShadowCircleHeader" data-sentry-source-file="unsupported-plan.tsx">
        <Clock5 size={50} strokeWidth={1} data-sentry-element="Clock5" data-sentry-source-file="unsupported-plan.tsx" />
      </ShadowCircleHeader>
      <Subheadline2 textAlign="center" data-sentry-element="Subheadline2" data-sentry-source-file="unsupported-plan.tsx">Account not supported yet</Subheadline2>
      <YStack px="$2" gap="$4" $short={{
      px: 0
    }} data-sentry-element="YStack" data-sentry-source-file="unsupported-plan.tsx">
        <Paragraph textAlign="center" theme="alt1" data-sentry-element="Paragraph" data-sentry-source-file="unsupported-plan.tsx">
          We are actively working to integrate with additional providers and
          insurers.
        </Paragraph>
        <Paragraph textAlign="center" theme="alt1" data-sentry-element="Paragraph" data-sentry-source-file="unsupported-plan.tsx">
          In the meantime, please <Text bold data-sentry-element="Text" data-sentry-source-file="unsupported-plan.tsx">go ahead and start a case</Text>.
          Our team of experts will do their best to support you with your issue.
        </Paragraph>
        <Paragraph textAlign="center" theme="alt1" data-sentry-element="Paragraph" data-sentry-source-file="unsupported-plan.tsx">
          You will be able to connect to another account later.
        </Paragraph>
      </YStack>
    </ScreenViewShadowCircle>;
}